import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FullPageLoader } from '../shared/LoadingSpinner';

export const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, loading, permissions } = useAuth();
  const location = useLocation();

  if (loading) {
    return <FullPageLoader text="Verificando sesión..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredPermission && permissions && !permissions[requiredPermission]) {
    return <Navigate to="/forbidden" replace />;
  }

  return children;
};
